import { render, staticRenderFns } from "./ClientsDebt.vue?vue&type=template&id=0881c8da&scoped=true"
import script from "./ClientsDebt.vue?vue&type=script&lang=js"
export * from "./ClientsDebt.vue?vue&type=script&lang=js"
import style0 from "./ClientsDebt.vue?vue&type=style&index=0&id=0881c8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881c8da",
  null
  
)

export default component.exports